import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Button, Col, Dropdown, Row } from "antd";
import { Link, useLocation, useNavigate } from "react-router-dom";
import cn from "classnames";

import classes from "./Header.module.scss";
import Logo from "assets/images/svg/logo.svg";
import { Icon } from "components/Icon";
import { UserContext } from "../Layout";
import { useLogout } from "hooks/mutations/user-auth/useLogout";
import Language from "../Language/Language";
import QueryHook from "utils/queryHook";
import { stringify } from "querystring";

type ActiveSection = "#send-appeals" | "#faq" | "#about-platform" | "#use-platform";

const Header = () => {
	const { t } = useTranslation();
	const { pathname } = useLocation();
	const { user } = useContext(UserContext);
	const { MergeQueryParams, QueryParams } = QueryHook();
	const { userType } = QueryParams;
	const navigate = useNavigate();
    const [isScrolling, setIsScrolling] = useState(false);
	const logoutMutation = useLogout();

	const [activeSection, setActiveSection] = useState<string | undefined>();

	const menu = [
		{ label: t("Мурожаат юбориш"), value: "#send-appeals" },
		{ label: t("Платформадан фойдаланиш"), value: "#use-platform" },
        { label: t("FAQ"), value: "#faq" },
        { label: t("Платформа ҳақида"), value: "#about-platform" }
	];

	useEffect(() => {
        onScrolling();
		window.addEventListener("scroll", onScrolling);
		return () => {
			window.removeEventListener("scroll", onScrolling);
		};
	}, []);

    const onScrolling = () => {
		const scrollPosition = window.scrollY; // => scroll position
		if (pathname === "/") {
			if (scrollPosition > 795 && scrollPosition < 1554) {
				setActiveSection("#use-platform");
			} else if (scrollPosition > 1553 && scrollPosition < 2370) {
                setActiveSection("#faq");
            } else if (scrollPosition > 2369) {
				setActiveSection("#about-platform");
			}else {
				setActiveSection(undefined);
			}
		} else {
			if (scrollPosition > 85) {
				setActiveSection("#send-appeals");
			} else {
				setActiveSection(undefined);
			}
		}
	};

    const scrollToSection = (sectionId: string) => {
        const section = document.getElementById(sectionId);
        if (section) {
            const yOffset = sectionId === "#send-appeals" || sectionId === "#use-platform" ? -120 : -55;
            const y = section.getBoundingClientRect().top + window.pageYOffset + yOffset;
            window.scrollTo({top: y, behavior: 'smooth'});
        }
    };

	const handleLogout = () => {
		localStorage.removeItem("token");
		window.location.href = "/";
		logoutMutation.mutate(
			{},
			{
				onSuccess() {
					localStorage.removeItem("token");
					window.location.href = "/";
				}
			}
		);
	};

    const handleScroll = () => {
        if (window.scrollY > 0) {
            setIsScrolling(true);
        } else {
            setIsScrolling(false);
        }
    };
    window.addEventListener('scroll', handleScroll);

	return (
        <div className={cn(classes.header, isScrolling && classes.fixed)}>
            <div className="container">
                    <Row gutter={[20, 20]} className={classes["header-content"]} align={"middle"}>
                        <Col lg={4} className={"d-flex"}>
                            <Link to={`/`} className={classes.logo}>
                                <img src={Logo} alt="" />
                                <span>{t(`Солиқ органлари билан "Қайта алоқа" ахборот тизими`)}</span>
                            </Link>
                        </Col>
                        <Col lg={14} className={"flex-center"}>
                            <nav>
                                <ul>
                                    {menu.map(({ label, value }, index) => (
                                        <li
                                            key={index}
                                            className={cn(
                                                (activeSection ? activeSection === value : pathname === "/" ? index === 0 : false) &&
                                                classes.active
                                            )} onClick={() => {
                                            scrollToSection(value)
                                            setActiveSection(value)
                                        }}>
                                            <a>{label}</a>
                                        </li>
                                    ))}
                                </ul>
                            </nav>
                        </Col>
                        <Col lg={6} className="flex-center gap30">
                            <Language />
                            {user?.pinfl ? (
                                <div className={classes["account"]}>
                                    <p>{user.fio}</p>
                                    <Dropdown
                                        menu={{
                                            items: [
                                                {
                                                    key: "1",
                                                    label: <p onClick={handleLogout}>{t("Чиқиш")}</p>
                                                }
                                            ]
                                        }}>
                                        <div onClick={(e) => e.preventDefault()}>
                                            <Icon size={24} icon={"avatar"} />
                                        </div>
                                    </Dropdown>
                                </div>
                            ) : (
                                <></>
                                // <Button onClick={() => navigate("/register")} className={classes["button"]} type="primary" size="large">
                                // 	{t("Рўйхатдан ўтиш")}
                                // 	<Icon size={16} color="#fff" icon={"chevronRight"} />
                                // </Button>
                            )}
                        </Col>
                    </Row>
                </div>
            {/** Sayt test rejimida ishlavotti dgan soz*/}
            <div className={classes.line}>
                <div className="container">
                    <div className={classes.box}>
                        <span>{t("Автоматлаштирилган тизим тест режимида ишга туширилди. Уни янада қулай қилиш бўйича таклифларингизни жўнатинг")}!</span>
                        <span>{t("Автоматлаштирилган тизим тест режимида ишга туширилди. Уни янада қулай қилиш бўйича таклифларингизни жўнатинг")}!</span>
                    </div>
                </div>
            </div>
        </div>
	);
};

export default Header;
